// The one place the browser session is read from and written to.
//
// It lives here rather than inside services/web.ts because the ported mail components
// (components/mail/backend.ts) also need to attach the user's bearer token, and the alternative
// was a second copy of the key and the JSON.parse. A duplicated auth read is how one half of an
// app keeps working after a session change and the other half quietly 401s.
//
// Same key the login page writes, so the mail screens authenticate as whoever is signed in --
// they do NOT use the shared service token. Handing that token to the browser is what made every
// logged-in user an admin in the dev proxy.

export type StoredSession = { email?: string; role?: string; token?: string };

export const SESSION_KEY = "dimemotion-port:session";

export function readSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as StoredSession) : null;
  } catch {
    return null;
  }
}

export function writeSession(s: StoredSession | null): void {
  if (s) localStorage.setItem(SESSION_KEY, JSON.stringify(s));
  else localStorage.removeItem(SESSION_KEY);
}

/** Bearer header for the signed-in user, or {} when signed out. */
export function authHeaders(): Record<string, string> {
  const token = readSession()?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}
